import React, { Component } from 'react';
import { Card, CardBody, Input, Button } from 'reactstrap';
import actions from '../../api/actions';

class ForgotPassword extends Component {
  state = { email: '' };

  changeEmail(e) {
    this.setState({ ...this.state, email: e.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();

    actions.create('password', { email: this.state.email }).then(r => {
      this.setState({ ...this.state, message: r.data.message });
    });
  }

  render() {
    const { email, message } = this.state;
    return (
      <Card className="register-panel mt-5 w-50 mx-auto" header="Register">
        <CardBody>
          <h2 className="text-center mb-3">
            Enter your account email:
          </h2>
          <form onSubmit={this.handleSubmit.bind(this)} className="text-center">
            <Input onChange={this.changeEmail.bind(this)} type="email" value={email} required="true" className="mb-4"/>
            <p>{message}</p>
            <Button color="success"
                    type="submit"
                    disabled={!email}
                    className="w-50">
              Submit
            </Button>
          </form>
        </CardBody>
      </Card>
    );
  }
}

export default ForgotPassword;
